// AuthModal.jsx
import React, {useState} from "react";
import Login from "./Login";
import Register from "./Register";
import ResetPassword from "./ResetPassword";

export default function AuthModal({onClose, style}) {
  const [mode, setMode] = useState("login"); // login | register | reset
  const handleSwitch = (next) => {
    setMode(next);
  };

  return (
    <div style={{...style}}>
      {mode === "login" && (
        <Login
          onClose={onClose}
          onSwitch={() => setMode("register")}
          onForgot={() => handleSwitch("reset")}

        />
      )}

      {mode === "register" && (
        <Register
          onClose={onClose}
          onSwitch={() => setMode("login")}
        />
      )}

      {mode === "reset" && (
        <ResetPassword
          onClose={onClose}
          onSwitch={() => setMode("login")}
        />
      )}
    </div>
  );
}